<form class="form-vertical" id="editdrugform" data-hook="editdrugform">
    <h3 ng-bind="vm.tmpdrug.name"></h3>
    <div class="row  form-group">
        <div class="col-xs-12 col-md-3">
            <!-- Einnahmeanweisung -->
            <div class="form-group">
                <label for="newdrugamount">Einnahme <span uib-tooltip="Plichtfeld">*</span> <sprhelp tip="Ausw&auml;hlen oder eingeben" descref="vm.sprsignature"></sprhelp>  </label>
                <div class="input-group">
                    <input class="form-control" ng-model="vm.tmpdrug.amount" id="newdrugamount"
                           autocomplete="noway" autocorrect="off" autocapitalize="off" spellcheck="false"
                           placeholder="1-0-1-0" ng-required="!vm.tmpdrug.amount"
                           ng-class="{ 'has-error': newdrugform.$invalid }">
                    <div class="input-group-btn" uib-dropdown>
                        <button type="button" class="btn btn-default" uib-dropdown-toggle><span class="caret"></span>
                        </button>
                        <ul id="amountmenu" class="dropdown-menu dropdown-menu-right" role="menu" uib-dropdown-menu
                            ng-hide="vm.conf.drugsignature.length">
                            <li ng-click="vm.tmpdrug.amount='1-0-0'">1-0-0</li>
                            <li ng-click="vm.tmpdrug.amount='1-0-1'">1-0-1</li>
                            <li ng-click="vm.tmpdrug.amount='0-1-0'">0-1-0</li>
                            <li ng-click="vm.tmpdrug.amount='0-0-1'">0-0-1</li>
                            <li ng-click="vm.tmpdrug.amount='1-1-1'">1-1-1</li>
                            <li ng-click="vm.tmpdrug.amount='0-0-0-1'">0-0-0-1</li>
                        </ul>
                        <ul id="amountmenu2" class="dropdown-menu dropdown-menu-right" role="menu" uib-dropdown-menu
                            ng-show="vm.conf.drugsignature.length">
                            <li ng-repeat="sig in vm.conf.drugsignature" ng-click="vm.tmpdrug.amount=sig">{{sig}}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-md-3">
            <!--Packungsgroesse-->
            <label for="newdrugpkgsize">Packungsgröße <sprhelp tip="Packungsgr&ouml;&szlig;e" descref="vm.sprpkgsize"></sprhelp></label>
            <input class="form-control" ng-model="vm.tmpdrug.pkgsize" id="newdrugpkgsize"
                   placeholder="30 Stk">
        </div>
        <div class="col-xs-12 col-md-3">
            <label for="newdrugamount">Packungsanzahl <span uib-tooltip="Plichtfeld">*</span> <sprhelp tip="Anzahl" descref="vm.sprpkgnr"></sprhelp></label>
            <!--OP-->
            <div class="radio" ng-init="vm.tmpdrug.op='OP I'">
                <label for="newdrugop1" class="radio-inline">
                    <input type="radio" value="OP I" required
                           ng-model="vm.tmpdrug.op"
                           id="newdrugop1">OP I</label>
                <label for="newdrugop2" class="radio-inline">
                    <input type="radio" value="OP II"
                           ng-model="vm.tmpdrug.op"
                           id="newdrugop2">OP II</label>
                <label for="newdrugop3" class="radio-inline">
                    <input type="radio" value="OP III"
                           ng-model="vm.tmpdrug.op"
                           id="newdrugop3">OP III</label>
            </div>
        </div>
        <div class="col-xs-12 col-md-3">
            <!--Dauermedikation-->
            <label for="newdrugamount">Einnahmedauer <sprhelp tip="Dauermedikation vs. Anla&szlig;medikation" descref="vm.sprduration"></sprhelp></label>
            <div class="input-group">
                <div class="checkbox">
                    <label for="newdrugperm" class="checkbox-inline">
                        <input type="checkbox"
                               ng-model="vm.tmpdrug.permanent"
                               id="newdrugperm">Dauermedikamentation
                    </label><br>
                </div>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-xs-12 col-md-6">
            <!--Rezeptvermerk-->
            <div class="row">
                <div class="col-xs-12">
                    <div class="form-group">
                        <label for="newdrugcomment">Rezeptvermerk</label>
                        <textarea class="form-control" ng-model="vm.tmpdrug.comment" id="newdrugcomment"
                                  placeholder=""></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-md-6">
            <div class="input-group">
                <strong>Spezifika</strong>

                <!--IND-->
                <div class="checkbox">
                    <label for="newdrugind" class="checkbox-inline">
                        <input type="checkbox"
                               ng-model="vm.tmpdrug.ind"
                               id="newdrugind">IND (Indikation)
                        <!-- <span ng-show="vm.tmpdrug.indcriteria" uib-tooltip="Indikationen"
                               uib-popover-template="vm.tmpdrug.indpopovertpl"
                               popover-title="Indikationen" popover-placement="auto bottom"><i class="fa fa-info-circle btn btn-primary"></i></span> -->
                    </label><br>
                    <label for="newdrugexpnoct" class="checkbox-inline">
                        <input type="checkbox"
                               ng-model="vm.tmpdrug.expnoc"
                               id="newdrugexpnoct">Exp. Noct. (Nachtausgabe)
                    </label><br>
                </div>

            </div>
        </div>
    </div>
    <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">
        <h3><i class="fa fa-check"></i> drug erfolgreich gespeichert!</h3>
    </div>
    <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
        <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen drug wurde abgebrochen!</h3>
    </div>
    <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">
        <h3>
            <i class="fa fa-warning"></i> drug konnte nicht gespeichert werden,
            der Fehler wurde protokolliert!
        </h3>
    </div>

    <div class=" row">
        <div class="col-xs-12">
            <div class="form-group">
                <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>
                <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>
            </div>
        </div>
    </div>
</form>